import React, { Fragment, useState } from 'react'
import ProjectInitiation from '../../Common/Component/ProjectInitiation';

const UserProjectInit = () => {
    return (
        <Fragment>
            <ProjectInitiation />
        </Fragment>
    )
}

export default UserProjectInit